import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { SupportAppPayload } from "./validation";

export const useGetSupportApp = (params?: string) =>
  useQuery<ApiResponse<DataPaginate<SupportAppResponse>>>({
    queryKey: ["useGetSupportApp", params],
    queryFn: () => fetcher(`website-config/support-apps?${params}`),
  });

export const useGetSupportAppById = (id?: number) =>
  useQuery<ApiResponse<DataObject<SupportAppResponse>>>({
    queryKey: ["useGetSupportAppById", id],
    queryFn: () => fetcher(`website-config/support-apps/${id}`),
    enabled: !!id,
  });

export const useSupportAppMutation = (id: number) => {
  return useFormMutation<
    ApiResponse<DataObject<any>>,
    Error,
    SupportAppPayload
  >({
    mutationFn: async (payload) => {
      return await sendData(
        id
          ? `website-config/support-apps/${id}`
          : `website-config/support-apps`,
        payload,
        id ? "PUT" : "POST"
      );
    },
    successMessage: `Berhasil ${id ? "Mengupdate" : "Menambah"} Data`,
  });
};
